<template>
  <div id="CreateReturnSelectType" class="bg-light px-3 create-return-select-type crst">
    <div class="col">
      <br>
      <div class="row no-gutters">
        <div v-if="allReturnsBlackedOut" class="crst__surplus-blackout-text">
          <p>
            <strong>{{ allReturnsBlackedOutMessage }}
              <a
                id="returnsPolicyLink"
                href="#"
                @click="GetReturnsPolicy()"
              >Returns Policy</a>
            </strong>
          </p>
        </div>
        <div v-else-if="isExpressBlackedOut" class="crst__surplus-blackout-text">
          <p>
            <strong>{{ expressReturnsBlackoutEndDateText }}
              <a
                id="returnsPolicyLink"
                href="#"
                @click="GetReturnsPolicy()"
              >Returns Policy</a>
            </strong>
          </p>
        </div>
        <div v-else-if="isSurplusBlackedOut" class="crst__surplus-blackout-text">
          <p>
            <strong>{{ surplusBlackoutEndDateText }}
              <a
                id="returnsPolicyLink"
                href="#"
                @click="GetReturnsPolicy()"
              >Returns Policy</a>
            </strong>
          </p>
        </div>
        <p v-if="!allReturnsBlackedOut">Enter a reference number below, as soon as you complete this step your return is stored and can be accessed later:</p>
      </div>
      <br>
      <div v-if="!allReturnsBlackedOut" class="row no-gutters">
        <div id="dealerReference" class="col">
          <div class="row no-gutters">
            <strong>Dealer Reference Number&nbsp; </strong>
          </div>

          <div class="row">
            <div class="col">
              <b-form-group
                id="ReferenceNumber"
                class="input-group"
                label-for="dealerReferenceNumber"
                label-class="font-weight-bold required"
                aria-label="Dealer Reference Number"
                aria-describedby="ReferenceNumber"
              >
                <b-form-input
                  id="dealerReferenceNumber"
                  class="crst__input"
                  v-model="returnDraftDto.ReferenceNumber"
                  v-validate="{required: true, max: 35}"
                  type="text"
                  name="ReferenceNumber"
                  aria-describedby="dealerReferenceLiveFeedback"
                  :state="ValidateState('ReferenceNumber')"
                />
                <b-form-invalid-feedback id="dealerReferenceLiveFeedback">
                  Dealer Reference Number is Required
                </b-form-invalid-feedback>
                <b-form-valid-feedback />
              </b-form-group>
            </div>
          </div>
        </div>

        <div id="returnType" class="col no-gutters">
          <div class="row">
            <strong>Return Type&nbsp;</strong>
          </div>
          <div class="row input-group">
            <b-form-select
              id="returnTypeDdl"
              v-model="returnDraftDto.ReturnDraftType"
              v-validate="{required: true, is_not: ''}"
              class="form-control col-md-6"
              :options="returnType"
              name="ReturnType"
              aria-describedby="returnType"
              :state="ValidateState('ReturnType')"
            >
              <template slot="first">
                <option :value="''" disabled>
                  Select Type
                </option>
              </template>
            </b-form-select>
            <b-form-invalid-feedback id="returnTypeLiveFeedback">
              Return Type is Required.
            </b-form-invalid-feedback>
            <b-form-valid-feedback />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {ReturnsService} from "@/services/ReturnsService"
  import {inputValidateState} from "@/components/mixins/inputValidateState"
  import { mapGetters }           from "vuex"
import { formatDateTime, stringHelper } from "@/components/mixins";

  export default {
    mixins: [inputValidateState, stringHelper, formatDateTime],
    computed:{
        ...mapGetters(["McfCostCenterId", "getContentItem", "activeDealer"]),

        allReturnsBlackedOutMessage(){
            return this.format(this.getContentItem("ReturnBlackoutMessage"), this.getLocalDate(this.surplusReturnsBlackoutEndDate), this.getLocalDate(this.expressReturnsBlackoutEndDate))
        },
        surplusBlackoutEndDateText(){
            return this.format(this.getContentItem("ReturnSurplusBlackoutMessage"), this.getLocalDate(this.surplusReturnsBlackoutEndDate))
        },
        expressReturnsBlackoutEndDateText(){
            return this.format(this.getContentItem("ReturnExpressBlackoutMessage"), this.getLocalDate(this.expressReturnsBlackoutEndDate))
        },
        allReturnsBlackedOut(){
          return this.isSurplusBlackedOut && this.isExpressBlackedOut
        }
    },
    
    props:{
      validationState: {
        type: Object,
        default: () => ({}),
        stepOne: {type: Boolean, default: false},
        stepTwo: {type: Boolean, default: false},
        stepThree: {type: Boolean, default: false},
        stepFour: {type: Boolean, default: false}
      },
      returnDraftDto: {
        type: Object,
        default: () => ({})
      }
    },
    data: () => ({
      returnType: [],
      isSurplusBlackedOut: false,
      isExpressBlackedOut: false,
      surplusReturnsBlackoutStartDate: null,
      surplusReturnsBlackoutEndDate: null,
      expressReturnsBlackoutStartDate: null,
      expressReturnsBlackoutEndDate: null
    }),
    created() {
      ReturnsService.GetReturnTypes(this.activeDealer.AccountSalesOrg.DirectDealerFlag).then (returnTypeList => {
        this.returnType = returnTypeList.data;
      });
      ReturnsService.GetBlackoutStatus(this.McfCostCenterId).then(blackoutStatus => {
        this.isSurplusBlackedOut = blackoutStatus.data.SurplusReturnsBlackedOut;
        this.isExpressBlackedOut = blackoutStatus.data.ExpressReturnsBlackedOut;
        this.surplusReturnsBlackoutStartDate = blackoutStatus.data.SurplusReturnsBlackOutStartDate;
        this.surplusReturnsBlackoutEndDate = blackoutStatus.data.SurplusReturnBlackOutEndDate;
        this.expressReturnsBlackoutStartDate = blackoutStatus.data.ExpressReturnsBlackOutStartDate;
        this.expressReturnsBlackoutEndDate = blackoutStatus.data.ExpressReturnsBlackOutEndDate;
      });
    },
    mounted(){
      if( this.returnDraftDto.ReturnDraftType !== ""){
        document.getElementById("returnTypeDdl").disabled = "true";
      }
    },
    updated(){
      this.$validator.validateAll().then(result => {
        this.validationState.stepOne = result;
      });
    },
    methods: {
      GetReturnsPolicy: function(){
        ReturnsService.GetReturnsPolicyTitle().then(title => {
          window.open(ReturnsService.GetReturnsPolicyUrl(title.data));
        });
      },
      
    }
  }
</script>
<style lang="scss" scoped>
.crst{
  padding-top: 2em;
  margin-top: 5px;
}
.crst__surplus-blackout-text{
  width: 100%;
  font-size: 1.2em;
}

</style>
